<template>
  <div>
    <el-row class="">
      <el-col :span="24">
        <img class="banner" src="@/assets/images/index_1.jpg" alt=""
      /></el-col>
    </el-row>

    <el-row class="ban3 hidden-xs-only" type="flex" justify="center">
      <el-col class="" :sm="8" :md="6" :gutter="20"
        ><div>
          <img src="@/assets/images/ban1.png" alt="" />专业的研发团队
        </div></el-col
      >
      <el-col :xs="8" :sm="8" :md="6" :gutter="20"
        ><div>
          <img src="@/assets/images/ban2.png" alt="" />优秀的技术支持
        </div></el-col
      >
      <el-col :xs="8" :sm="8" :md="6" :gutter="20"
        ><div>
          <img src="@/assets/images/ban3.png" alt="" />完善的售后服务
        </div></el-col
      >
    </el-row>

    <el-row class="aboutus" type="flex" justify="center">
      <el-col class="img hidden-sm-and-down" :xs="24" :sm="6" :md="6"
        ><img src="@/assets/images/222.jpg" alt=""
      /></el-col>
      <el-col :xs="24" :sm="20" :md="12"
        ><div class="txt">
          <h1>
            关于我们<img class="next" src="@/assets/images/ge.png" alt="" />
          </h1>
          <p>
            苏州飞康生物医药有限公司成立于2014年，总部位于苏州市太仓生物港。公司集研发、生产和销售为一体，
            是一家致力于发展快速、准确和方便的智能健康设备和POCT体外诊断试剂的高技术企业。
          </p>
          <p>
            首席执行官王锋博士
            清华大学生物系硕士学位、美国哥伦比亚大学博士后/副研究员，在《自然结构分子生物学》等顶尖杂志发表论文,领导开发了多款应用于家庭的健康检测产品。
          </p>
          <p>
            首席技术官戴星灿博士
            清华大学物理系硕士学位、清华大学物理系副教授兼博士生导师，主持和参与国家重大科学研究计划、中国自然科学基金重大研究计划和中国自然科学基金多个项目的研究。
          </p>
          <a class="btn" href="./aboutus">了解更多>> </a>
        </div></el-col
      >
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="18" class="ge"></el-col>
    </el-row>

    <div class="center">
      <h1>我们的产品</h1>
      <img class="next" src="@/assets/images/ge.png" alt="" />
    </div>

    <el-row type="flex" justify="center">

      <el-col class="pdt" :xs="24" :sm="6">
        <div class="product">
          <a href="" @click="handleGo('/product/lh')">
            <div class="pic">
              <img src="@/assets/images/f2-2.png" alt="" />
            </div>
            <div class="txt">
              <h3>智能免疫层析定量一体机</h3>
              <p>
                <span>了解更多>></span>
              </p>
            </div>
            <div class="mask"></div>
          </a>
        </div>
      </el-col>

      <el-col class="pdt" :xs="24" :sm="6">
        <div class="product">
          <a href="" @click="handleGo('/product/amh')">
            <div class="pic">
              <img src="@/assets/images/f6.png" alt="" />
            </div>
            <div class="txt">
              <h3>一滴血卵巢功能检测(AMH测定)</h3>
              <p>
                <span>了解更多>></span>
              </p>
            </div>
            <div class="mask"></div>
          </a>
        </div>
      </el-col>

      <el-col class="pdt" :xs="24" :sm="6">
        <div class="product">
          <a href="" @click="handleGo('/product/twt')">
            <div class="pic">
              <img src="@/assets/images/f1.png" alt="" />
            </div>
            <div class="txt">
              <h3>儿童智能体温贴</h3>
              <p>
                <span>了解更多>></span>
              </p>
            </div>
            <div class="mask"></div>
          </a>
        </div>
      </el-col>

    </el-row>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/display.css";
export default {
  name: "FirstPage",
  data() {
    return {};
  },
  methods: {
    handleGo(target) {
      this.$router.push(target);
    },
  },
};
</script>

<style lang="less" scoped>
.ban3 {
  text-align: center;
  height: 70px;
  width: 100%;
  margin-bottom: 40px;
  background-image: linear-gradient(
    to right,
    rgb(100, 16, 173),
    rgb(84, 173, 233)
  );
  div {
    display: flex;
    height: 100%;
    color: white;
    align-items: center;
    justify-content: center;
  }
  img {
    height: 50px;
    width: 50px;
    margin-right: 20px;
  }
}
.aboutus {
  flex-wrap: wrap;
  img {
    height: auto;
    width: 100%;
  }
  .next {
    width: auto;
    height: auto;
  }
  .txt {
    margin: 0 20px;
    h1 {
      margin-bottom: 20px;
    }
    p {
      margin-bottom: 10px;
    }
    .btn {
      color: rgb(100, 16, 173);
    }
  }
}
.center {
  text-align: center;
  margin-top: 30px;
}
.ge {
  margin-top: 30px;
  height: 2px;
  // width: 100%;
  background-color: rgb(206, 206, 206);
}
.el-row {
  flex-wrap: wrap;
}
.pdt {
  margin-top: 20px;
  width: 370px;
  margin: auto 20px;
}
.pdt .txt {
  line-height: 30px;
  text-align: center;
  margin-bottom: 30px;
}
.pdt .mask {
  position: absolute;
  top: 0;
  opacity: 0;
  height: 300px;
  width: 370px;
  background-image: linear-gradient(
    transparent 70%,
    rgba(100, 16, 173, 0.5) 30%
  );
  transition: all 0.5s;
}

.pdt .product {
  position: relative;
  border: 1px solid rgb(100, 16, 173, 0.5);
  border-radius: 10px;
  margin-bottom: 20px;
  overflow: hidden;
  height: 300px;
  width: 370px;
}
.pdt img {
  transition: all 0.5s;
  height: 300px;
  width: 370px;
}
.pdt a {
  display: block;
  transition: all 0.5s;
  height: 300px;
  width: 370px;
}
.pdt .txt {
  position: absolute;
  width: 370px;
  bottom: -55px;
  z-index: 2;
  color: rgb(76, 76, 76);
  text-align: center;
  font-size: 20px;
  font-weight: 700;
}
.pdt .txt span {
  top: 40px;
  font-size: 16px;
}

.pdt a:hover .mask {
  opacity: 1;
}
.pdt a:hover img {
  transform: scale(1.1);
}
.pdt a:hover .txt {
  transform: translateY(-35px);
  color: white;
}
</style>
